export const RoutePrefix = '/superuser';

/**
 * Returns the prefixed url for given route.
 * TODO: It would be better if general components worked with relative routes instead, hardcoding is bad.
 *
 * @param viewContext
 * @param nonPrefixedRoute eg. '/something/somewhere'
 */
export const getPrefixedViewUrl = (nonPrefixedRoute: string): string => {
  return `${RoutePrefix}${nonPrefixedRoute}`;
}
